import { remarkCitations } from "@/components/assistant-ui/citation";
import { defaultComponents } from "@/components/assistant-ui/markdown-text";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

export function MarkdownRendering({ children }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkCitations, remarkMath]}
      rehypePlugins={[[rehypeKatex, { output: "html" }]]}
      components={defaultComponents}
    >
      {children}
    </ReactMarkdown>
  );
}
